




























































import Vue from 'vue';
import { dayAbbrevFormat, dateTransactionAbbrevFormat } from '@/constants';
import { EventBus } from '@/event-bus';
import { ButtonGroup } from '@/components/account-components';
import { HistoryTransactionResponseModel } from '@/@types/member';

interface Data {
  dayAbbrevFormat: string;
  dateTransactionAbbrevFormat: string;
  isLoading: boolean;
}

export default Vue.extend({
  name: 'RecentActivity',
  props: {
    accountId: {
      type: String,
      default: '',
    },
    noTransactionsText: {
      type: String,
      default: '',
    },
    showActivityButton: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dayAbbrevFormat,
      dateTransactionAbbrevFormat,
      isLoading: false,
    };
  },
  computed: {
    transactions(): HistoryTransactionResponseModel[] {
      return this.$store.getters.transactionHistory;
    },
    noTransactionsMessage(): string {
      return this.noTransactionsText
        ? this.noTransactionsText
        : this.$options.filters.t('global_no-transactions');
    },
  },
  components: {
    ButtonGroup,
  },
});
